import type { NextPage } from 'next';
import { useRouter } from 'next/router';

import { GlobalCommentList, Head, Layout, SelectButton } from '~/components';
import {
  GLOBAL_COMMENTS_FILTER,
  GLOBAL_COMMENTS_FILTER_VOTE_OPTION,
  GLOBAL_COMMENTS_FILTER_VOTE_OPTION_DISPLAY,
} from '~/constants';
import useCheckAppVersion from '~/hooks/useCheckAppVersion';
import type {
  GlobalCommentsFilter,
  GlobalCommentsFilterVoteOption,
} from '~/types';

import styles from '../comments.module.scss';

interface CommentsPageProps {}

const CommentsPage: NextPage<CommentsPageProps> = ({}: CommentsPageProps) => {
  useCheckAppVersion();
  const router = useRouter();
  const { sort, duration } = router.query as {
    sort: GlobalCommentsFilter;
    duration?: GlobalCommentsFilterVoteOption;
  };
  const restorationKey = `comment_${sort}${duration ? `_${duration}` : ''}`;

  return (
    <>
      <Head title="Comments" />
      <Layout>
        <div className={styles.container}>
          <div className={styles.inner_container}>
            <div className={styles.filter_container}>
              <div className={styles.filter_sort}>
                <SelectButton
                  active={sort === GLOBAL_COMMENTS_FILTER.NEW}
                  onClick={() =>
                    router.push(
                      {
                        pathname: `/comments/[sort]`,
                        query: { sort: GLOBAL_COMMENTS_FILTER.NEW },
                      },
                      undefined
                    )
                  }
                >
                  New
                </SelectButton>
                <SelectButton
                  active={sort === GLOBAL_COMMENTS_FILTER.VOTE}
                  onClick={() =>
                    sort === GLOBAL_COMMENTS_FILTER.VOTE
                      ? {}
                      : router.push(
                          {
                            pathname: `/comments/[sort]`,
                            query: {
                              sort: GLOBAL_COMMENTS_FILTER.VOTE,
                              duration:
                                GLOBAL_COMMENTS_FILTER_VOTE_OPTION.TODAY,
                            },
                          },
                          undefined
                        )
                  }
                >
                  Top
                </SelectButton>
              </div>
              {sort === GLOBAL_COMMENTS_FILTER.VOTE && (
                <SelectButton.Group
                  key={duration}
                  items={Object.entries(GLOBAL_COMMENTS_FILTER_VOTE_OPTION).map(
                    ([key, value]) => ({
                      key,
                      label:
                        GLOBAL_COMMENTS_FILTER_VOTE_OPTION_DISPLAY[
                          key as keyof typeof GLOBAL_COMMENTS_FILTER_VOTE_OPTION
                        ],
                      selected: value === duration,
                      value,
                    })
                  )}
                  onItemClicked={(clickedItem) =>
                    router.push(
                      {
                        pathname: `/comments/[sort]`,
                        query: {
                          sort: GLOBAL_COMMENTS_FILTER.VOTE,
                          duration: clickedItem[0]
                            .value as GlobalCommentsFilterVoteOption,
                        },
                      },
                      undefined,
                      { shallow: false }
                    )
                  }
                />
              )}
            </div>
            <GlobalCommentList
              key={restorationKey}
              restorationKey={restorationKey}
              sort={sort}
              duration={duration}
            />
          </div>
        </div>
      </Layout>
    </>
  );
};

export default CommentsPage;
